module.exports = __webpack_public_path__ + "static/media/Fire.244d2968.ogg";